import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { SpaceoKub } from 'landings/spaceo-kub';
import { RemoteProps } from './widgets-types';

export const SpaceoKubRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <SpaceoKub />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
